import WelcomeCard from './WelcomeCard.js';

export default WelcomeCard;
